export class mdlProposalSaveRes{

    public StatusCode: string;
    public StatusDesc: string;
    public StatusDescAr: string;
    public ProposalNo: string;
    public PaymentObj:mdlGetPayfortFieldsReq=new mdlGetPayfortFieldsReq();
}

export class mdlGetPayfortFieldsReq{
    public UserId: string;
    public ProductCode: string;
    public ProposalNo: string;
    public TotalPremium: string;
    public InsuredIdNo: string;
    public InsuredName: string;
    public ChasissNo: string;
    public PMethod: string;
    public MobileNo: string;
    public PaySign: string;
    public RequestType: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlGetPayfortFieldsReq.ts